import { render, staticRenderFns } from "./EditModes.vue?vue&type=template&id=4fc23b72&lang=pug&"
import script from "./EditModes.vue?vue&type=script&lang=js&"
export * from "./EditModes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports